import React, { FC, memo, useEffect, useRef } from "react";
import clsx from "clsx";
import ReactDOM from "react-dom";

import s from "./Modal.less";
interface Props {
  title?: string;
  children: React.ReactChildren | any;
  w?: number;
  actionClose?: () => void;
  isOpen: boolean;
  withCloseBtn?: boolean;
  customClassName?: string;
  customClassLayout?: string;
  withoutMargin?;
}

const Modal: FC<Props> = memo(
  ({
    title,
    children,
    w,
    isOpen,
    actionClose,
    withCloseBtn = true,
    customClassName = "",
    customClassLayout,
    withoutMargin,
  }) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const divRef = useRef(null);

    // Блокировка скролла при открытии модалки
    useEffect(() => {
      if (isOpen) {
        // Сохраняем текущее значение overflow
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;

        // Получаем ширину скроллбара
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        // Блокируем скролл и компенсируем ширину скроллбара
        document.body.style.overflow = "hidden";
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }

        // Возвращаем функцию очистки
        return () => {
          document.body.style.overflow = originalOverflow;
          document.body.style.paddingRight = originalPaddingRight;
        };
      }
    }, [isOpen]);

    if (!isOpen) {
      return null;
    }

    return ReactDOM.createPortal(
      <>
        <div className={s.container_modal} ref={divRef}>
          <div
            className={clsx(customClassLayout, s.modal_overlay)}
            onClick={actionClose}
          />
          <div
            ref={modalRef}
            className={clsx(s.modal, {
              [customClassName]: true,
            })}
            style={w ? { width: `${w}px`, maxWidth: `${w}px` } : undefined}
          >
            {title && <div className={s.title}>{title}</div>}
            {withCloseBtn && (
              <div className={s.button_close} onClick={actionClose}>
                <div className={s.cl_btn_2}>
                  <div>
                    <div className={s.leftright} />
                    <div className={s.rightleft} />
                  </div>
                </div>
              </div>
            )}
            <div className={clsx(s.body, { [s.withoutMargin]: withoutMargin })}>
              {children}
            </div>
          </div>
        </div>
      </>,
      document.getElementById("modal")
    );
  }
);

export default Modal;
